import { useAuth } from 'auth/hooks/useAuth';
import Moment from 'moment';
import { Grid } from '@orbita-ui/core';
import { HomeContainer } from './HomePage.styles';
import { PageTitle } from 'shared/components/Fonts';

export function HomePage() {
  const { user } = useAuth();

  const formatDate = () => {
    const date = Moment(user?.lastLogin);
    return date.format('DD/MM/YYYY HH:mm');
  };

  return (
    <HomeContainer>
      <div className="info">
        <Grid>
          <Grid.Item>
            <PageTitle>
              Te damos la bienvenida a <span>Mis Tarjetas Recargables</span>
            </PageTitle>
          </Grid.Item>
          <Grid.Item>
            <p>
              La supervisión y el control de gastos corporativos son de vital importancia.
              Para facilitar esta gestión, Visa impulsa el desarrollo de nuevas
              herramientas en la plataforma de Tarjetas Recargables para Empresas. Con
              aplicaciones específicas para diferentes ámbitos (Administración de Flota,
              Administración de Gastos de Representación, Compras Institucionales, etc.),
              ofrece soluciones completas para las empresas.
            </p>
          </Grid.Item>
          <Grid.Item>
            <p>
              El sistema facilita la reasignación en línea de saldos disponibles y
              proporciona la información necesaria para una adecuada rendición de gastos.
            </p>
          </Grid.Item>
        </Grid>
      </div>
      <div className="bottom">
        <p className="text-end">
          Último inicio de sesión: <span>{formatDate()}</span>
        </p>
      </div>
    </HomeContainer>
  );
}
